import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';

const FloatingCTA = () => {
  const phoneNumber = '07026303999';
  const whatsappMessage = encodeURIComponent(
    'Hello Shri Durga Enterprises! I am interested in your solar solutions. Please provide more information.'
  );

  return (
    <div className="fixed bottom-8 right-8 z-[9997] flex flex-col space-y-3">
      {/* WhatsApp Button */}
      <a
        href={`https://wa.me/91${phoneNumber}?text=${whatsappMessage}`}
        target="_blank"
        rel="noopener noreferrer"
        className="group relative"
      >
        <div className="bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full p-3 shadow-2xl transition-all duration-300 hover:scale-110 animate-bounce-slow">
          <MessageCircle className="w-6 h-6" />
        </div>
        <span className="absolute right-full mr-4 top-1/2 -translate-y-1/2 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          Chat on WhatsApp
        </span>
      </a>

      {/* Call Button */}
      <a
        href={`tel:${phoneNumber}`}
        className="group relative"
      >
        <div className="bg-[#22c55e] hover:bg-[#16a34a] text-white rounded-full p-3 shadow-2xl transition-all duration-300 hover:scale-110 animate-bounce-slow delay-200">
          <Phone className="w-6 h-6" />
        </div>
        <span className="absolute right-full mr-4 top-1/2 -translate-y-1/2 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          Call Now
        </span>
      </a>

      <style jsx>{`
        @keyframes bounce-slow {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }
        .animate-bounce-slow {
          animation: bounce-slow 2s infinite;
        }
        .delay-200 {
          animation-delay: 0.2s;
        }
      `}</style>
    </div>
  );
};

export default FloatingCTA;
